import axios from "@/widgets/shared/utils/axios-instance";
import {entityIdsOf, entityMapOf} from "@/widgets/shared/utils/entity-utils";
import { Constants } from "@/widgets/shared/constants";

export function state() {
  return {
    ids: [],
    meetings: {},
  };
}

export const mutations = {
  setMeetings(state, meetings) {
    state.ids = entityIdsOf(meetings);
    state.meetings = entityMapOf(meetings);
  },
};

export const actions = {
  async loadMeetings({ commit }, { eventId, componentIds }) {
    const ids = [].concat(componentIds);
    // eslint-disable-next-line prettier/prettier
    const requests = ids.map(id =>
      axios.get(`events/${eventId}/components/${id}/business_matching/invitations`)
    );

    const res = await Promise.all(requests);
    const meetings = res.reduce(reduceMeetings, []);
    const filteredMeetings = meetings.filter(meeting => {
      return meeting.status === Constants.BM_ACCEPTED_STATUS;
    });
    commit("setMeetings", filteredMeetings);
  },
};

function reduceMeetings(acc, { data }) {
  let { ingoing, outgoing } = data;
  ingoing = ingoing.map(meeting => ({ ...meeting, type: "ingoing" }));
  outgoing = outgoing.map(meeting => ({ ...meeting, type: "outgoing" }));

  return acc.concat(ingoing, outgoing);
}

export const getters = {
  meetingById: state => id => state.meetings[id],

  allMeetings(state, getters) {
    return state.ids.map(getters.meetingById);
  },

  visibleMeetings(state, getters) {
    // eslint-disable-next-line prettier/prettier
    return date =>
      getters["allMeetings"].filter(
        meeting => compareMeetingDate(meeting, date)
      );
  },
};

function compareMeetingDate(meeting, date) {
  const meetingDate = meeting.time_start.slice(0, 10);
  return meetingDate === date;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
